const API_BASE = "/api";

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, options);
  if (!res.ok) {
    let message = `云端请求失败 (${res.status})`;
    try {
      const data = await res.json();
      if (data?.error) message = data.error;
    } catch {
      // keep default message
    }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }
  const type = res.headers.get("content-type") || "";
  if (type.includes("application/json")) return res.json();
  return res;
}

export async function cloudHealth() {
  try {
    await request("/health");
    return true;
  } catch {
    return false;
  }
}

export async function listCloudFiles() {
  return request("/files");
}

export async function uploadCloudFile(blob, name) {
  const res = await fetch(`${API_BASE}/files`, {
    method: "POST",
    headers: {
      "Content-Type": blob.type || "application/octet-stream",
      "X-File-Name": encodeURIComponent(name || "unnamed"),
    },
    body: blob,
  });
  if (!res.ok) {
    let message = `上传失败 (${res.status})`;
    try {
      const data = await res.json();
      if (data?.error) message = data.error;
    } catch {
      // keep default message
    }
    throw new Error(message);
  }
  return res.json();
}

export async function getCloudFile(id) {
  return request(`/files/${encodeURIComponent(id)}`);
}

export async function deleteCloudFile(id) {
  return request(`/files/${encodeURIComponent(id)}`, { method: "DELETE" });
}

export async function createCloudShare(fileId, expiresDays = 0) {
  return request("/shares", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fileId, expiresDays }),
  });
}

export async function resolveCloudShare(token) {
  return request(`/shares/${encodeURIComponent(token)}`);
}

export function cloudShareLink(token) {
  const { origin, pathname, search } = location;
  return `${origin}${pathname}${search}#s=${encodeURIComponent(token)}`;
}
